import React from "react";
import Loader from "./Loader";

const Table = ({ list, tableHeadings, detailHandler, loading, searchQuery = "" }) => {
  const filteredList = list
    ?.filter(
      (item) =>
        item?.name.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
        item?.employee_id?.includes(searchQuery) ||
        item?.labor_item?.toLowerCase()?.includes(searchQuery?.toLowerCase())
    )
    .sort((a, b) => a.id - b.id);
  return (
    <>
      {loading && <Loader />}
      <div className="table-responsive crew-table all-crew-table data-table-shell user-table-shell">
        <table className="table table-striped tableV2 user-table">
          <thead>
            <tr>
              {tableHeadings?.map((item, key) => (
                <th scope="col" className="table-heading" key={key}>
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredList?.length > 0
              ? filteredList?.map((item, key) => (
                  <tr key={key}>
                    <td className="record-id">
                      <div>{item?.employee_id || "NA"}</div>
                    </td>
                    <td>{item?.name}</td>
                    <td>{item?.labor_item_description || "NA"}</td>
                    <td>
                      <span className="status-pill">
                        {item?.status ? item.status : "N/A"}
                      </span>
                    </td>
                    <td className="details-td table-actions">
                      <button
                        className="btn btn-info detail-btn"
                        onClick={() => detailHandler(item?.id)}
                      >
                        Details
                      </button>
                    </td>
                  </tr>
                ))
              : !loading && (
                  <tr>
                    <td colSpan="5">No data found</td>
                  </tr>
                )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Table;
